import { Client } from "@stomp/stompjs";
import { createContext, useEffect, useRef, useState } from "react";
import { socketUrl } from "../../config/baseURL";

export const GraphNotificationContext = createContext();
const { Provider } = GraphNotificationContext;
const unitId = localStorage?.getItem("unitId");
function GraphNotificationProvider({ children = null }) {
  const [graphNotification, setGraphNotification] = useState({});
  const clientRef = useRef(null);
  const unitId = localStorage.getItem("unitId")
    ? localStorage.getItem("unitId")
    : 1;
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (unitId && token) {
      const userClient = new Client({
        brokerURL: socketUrl,
        debug: function (str) {
          // console.log(str);
        },
      });
      clientRef.current = userClient;

      userClient.onConnect = function (frame) {
        // console.log("User connected====>>>>> " + frame);

        userClient.subscribe(
          `/user/exchange_${unitId ? unitId : 1}/queue/graph`,
          // `/user/diagram/queue/notifications`,
          (message) => {
            // console.log("Graph Notification received====>>>: ", message.body);
            try {
              const notification = JSON.parse(message.body);
              setGraphNotification(notification);
              console.log("Graph Notification content====>>> ", notification);
            } catch (e) {
              console.error("Failed to parse notification message:", e);
            }
          }
        );
      };

      userClient.onWebSocketError = (error) => {
        console.error("Error with websocket", error);
      };

      userClient.activate();

      return () => {
        userClient.deactivate();
      };
    }
  }, [unitId && token]);
  const stopSocket = () => {
    if (clientRef.current && clientRef.current.connected) {
      clientRef.current.deactivate();
      console.log("Socket disconnected manually.");
    }
  };

  const value = [graphNotification, stopSocket];

  return <Provider value={value}>{children}</Provider>;
}

export default GraphNotificationProvider;
